import React from "react";

const CheckOfferDetailsModal = ({
  isCheckOfferDetailsModalOpen,
  offerDetails,
  checkDetails,
  toggleCheckOfferDetailsModal,
}) => {
  return (
    isCheckOfferDetailsModalOpen && (
      <div
        className="modal fade show oil-check-details"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isCheckOfferDetailsModalOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            {offerDetails && checkDetails && (
              <>
                <div
                  className="modal-header orderDetails-modalHeader px-4 bg-opacity-10"
                  style={{ backgroundColor: checkDetails.background_color }}
                >
                  <i
                    onClick={toggleCheckOfferDetailsModal}
                    className="fa-solid fa-xmark fa-xl cursor"
                  ></i>
                  <p className="modal-title orderDetails-modalTitle mx-3 my-0 fs-5 fw-semibold">
                    {offerDetails.name}
                  </p>
                </div>
                <div className="modal-body orderDetails-modalBody p-3 text-end">
                  <h5> : يشتمل العرض علي </h5>
                  <p>{offerDetails.description}</p>

                  <div className="d-flex justify-content-between align-items-center fw-bold">
                    <div
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                      }}
                    >
                      <p className="fw-semibold">
                        {offerDetails.offer_price}
                        <span className="text-start"> بدلا من</span>
                        <span className="text-decoration-line-through mx-1">
                          {offerDetails.total_price}
                        </span>
                      </p>
                    </div>
                    <p> : السعر </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default CheckOfferDetailsModal;
